import { definePreset } from '@primeuix/themes';
import BASE from './dataunit';
import { DU_PALETTES } from './palettes';

// Extends the generated base preset with dataunit_blue as the default primary.
// At runtime ThemeService swaps the palette via updatePrimaryPalette().
export default definePreset(BASE, {
  semantic: {
    primary: DU_PALETTES.dataunit_blue,
  },
});
